import { cn } from "@/lib/utils";

const siteHeaderChromeBaseClass = cn(
	"sticky top-0 z-50 border-b backdrop-blur-xl transition-[box-shadow,background-color,border-color] duration-300",
	"before:pointer-events-none before:absolute before:inset-x-0 before:top-0 before:z-10 before:h-px",
	"before:bg-linear-to-r before:from-transparent before:via-black/5 before:to-transparent",
	"light:before:via-black/5",
	"dark:before:via-white/12",
	"border-border/40 bg-background/72 supports-[backdrop-filter]:bg-background/58",
	"dark:border-white/8 dark:bg-background/82 dark:supports-[backdrop-filter]:bg-background/68",
);

const siteHeaderChromeScrolledClass = cn(
	"border-border/55 bg-background/88 shadow-[0_10px_40px_-16px_rgba(0,0,0,0.12)]",
	"supports-[backdrop-filter]:bg-background/78",
	"light:shadow-[0_8px_32px_-14px_rgba(0,0,0,0.1)] light:supports-[backdrop-filter]:bg-background/85",
	"dark:border-white/10 dark:bg-background/92 dark:shadow-[0_12px_48px_-12px_rgba(0,0,0,0.65)]",
	"dark:supports-[backdrop-filter]:bg-background/85",
);

/** Shared top bar surface for marketing + auth (blur, border, optional scroll elevation). */
export function getSiteHeaderChromeClass(scrolled = false): string {
	return cn(
		siteHeaderChromeBaseClass,
		scrolled && siteHeaderChromeScrolledClass,
	);
}

/** @deprecated use getSiteHeaderChromeClass() */
export const siteHeaderChromeClass = getSiteHeaderChromeClass();
